module.exports = "https://web-assets.ifttt.com/packs/media/pro_trial/img-hello-card-web-general-min-4859e35a.jpg";